@let unbilled = store.data.getBilledOfferUnbilledCount();

<app-card [showHeader]="false">
    <ng-template #content>
        <div class="grid-2col_auto input-grid-gaps-small align-items-center">

            <div class="font-bold">{{ prefix + 'label' | translate }}</div>
            <div></div>

            <div>{{ prefix + 'totalCount' | translate }}</div>
            <div>{{ unbilled?.totalCount ?? 0 }}</div>

            <div>{{ prefix + 'firstWork' | translate }}</div>
            <div>
                @if (unbilled?.firstWork) {
                    <app-link-button (clickEvent)="goToWork(unbilled?.firstWork)">
                        {{ unbilled?.firstWork?.offers?.[0]?.serviceOffer?.name ?? '-' }}
                    </app-link-button>
                }
            </div>

            <div>{{ prefix + 'lastWork' | translate }}</div>
            <div>
                @if (unbilled?.lastWork) {
                    <app-link-button (clickEvent)="goToWork(unbilled?.lastWork)">
                        {{ unbilled?.lastWork?.offers?.[0]?.serviceOffer?.name ?? '-' }}
                    </app-link-button>
                }
            </div>

        </div>
    </ng-template>
</app-card>
